// Gestores (7-oct-2026): la pestaña «Gestión» de Analítica y los filtros de gestionados /
// propios / propietario de las pestañas Desempeño y Canales.
export const gestionAnalytics = {
  tab: "Gestion",
  tabRestricted: "Mon relevé",
  restrictedTitle: "Mon relevé",

  pageFilters: {
    ownership: "Hébergements",
    ownershipAll: "Gérés et en propre",
    ownershipManaged: "Gérés uniquement",
    ownershipOwn: "En propre uniquement",
    owner: "Propriétaire",
    allOwners: "Tous les propriétaires",
  },

  views: {
    business: "Mon activité",
    owners: "Propriétaires",
    expenses: "Dépenses",
  },

  filters: {
    listings: "Logements",
    allListings: "Tous",
    someListings: "{count} logements",
    owner: "Propriétaire",
    allOwners: "Tous",
    attribution: "Compter les réservations par",
    checkout: "Date de départ",
    checkin: "Date d'arrivée",
    nights: "Nuits de la période",
    attributionHelp: "Par départ, c'est ainsi que l'on règle les propriétaires : le séjour est déjà terminé.",
    attributionHelpLabel: "Que signifie « Compter les réservations par »",
    currency: "Devise",
  },

  warnings: {
    otaEstimated:
      "{count} réservation avec la commission OTA estimée au pourcentage : le canal n'a pas transmis la commission réelle. | {count} réservations avec la commission OTA estimée au pourcentage : le canal n'a pas transmis la commission réelle.",
    noBreakdown:
      "{count} réservation sans détail : tout son montant a été compté comme hébergement. | {count} réservations sans détail : tout leur montant a été compté comme hébergement.",
    outdatedBreakdown:
      "{count} réservation a été modifiée ou prolongée après son import : son montant actuel a été retenu. | {count} réservations ont été modifiées ou prolongées après leur import : leur montant actuel a été retenu.",
    otherCurrencies: "Certains hébergements sont dans une autre devise ({currencies}). Changez-la ci-dessus pour les voir.",
    noOwner:
      "{count} hébergement géré n'a pas de propriétaire attribué. | {count} hébergements gérés n'ont pas de propriétaire attribué.",
    assignOwners: "Attribuer des propriétaires",
  },

  states: {
    loadError: "Impossible de charger les données de gestion.",
    forbidden: "Vous n'avez pas l'autorisation de voir ces informations.",
    periodTooLong: "Choisissez une période de deux ans maximum.",
    retry: "Réessayer",
    noMovements: "Aucun mouvement sur cette période",
  },

  empty: {
    title: "Vous gérez des hébergements pour d'autres propriétaires ?",
    text: "Indiquez pour chaque hébergement que vous le gérez pour un propriétaire et à quelles conditions : votre commission, qui encaisse les réservations et comment le ménage est réparti. Vous verrez ici ce que vous gagnez et ce qui revient à chaque propriétaire.",
    point1: "Vos commissions, le ménage et vos dépenses, avec votre bénéfice réel",
    point2: "Ce qu'il faut verser à chaque propriétaire ou lui facturer",
    point3: "Le relevé de chaque propriétaire en PDF ou Excel",
    cta: "Configurer mes hébergements",
  },

  period: {
    subtitle: "{period} · {attribution} · {granularity}",
    byCheckout: "réservations par date de départ",
    byCheckin: "réservations par date d'arrivée",
    byNights: "nuits de la période",
    day: "par jour",
    week: "par semaine",
    month: "par mois",
  },

  counts: {
    reservations: "{count} réservation | {count} réservations",
    nights: "{count} nuit | {count} nuits",
    units: "{count} hébergement | {count} hébergements",
    ownUnits: "{count} hébergement en propre | {count} hébergements en propre",
    owners: "{count} propriétaire | {count} propriétaires",
  },

  business: {
    kpi: {
      managedGross: "Chiffre d'affaires géré",
      commissions: "Vos commissions",
      cleaning: "Ménage",
      ownRevenue: "Revenus des biens en propre",
      expenses: "Dépenses",
      profit: "Bénéfice",
    },
    vatLine: "+ TVA {amount}",
    ofTotal: "du chiffre d'affaires total",
    overManaged: "du chiffre d'affaires géré",
    ofIncome: "de vos revenus",
    margin: "de marge",
    chartTitle: "Revenus, dépenses et bénéfice",
    chartA11y: "Graphique des revenus, des dépenses et du bénéfice de la période",
    legend: {
      commissions: "Commissions",
      cleaning: "Ménage",
      own: "Biens en propre",
      expenses: "Dépenses",
      profit: "Bénéfice",
    },
    byCategory: "Dépenses par catégorie",
    category: "Catégorie",
    amount: "Montant",
    noExpenses: "Aucune dépense sur cette période",
    seeExpenses: "Voir les dépenses",
  },

  owners: {
    kpi: {
      gross: "Revenus des réservations",
      ota: "Commissions OTA",
      cleaning: "Ménage",
      commission: "Votre commission + TVA",
      commissionRestricted: "Commission du gestionnaire + TVA",
      charged: "Frais refacturés",
      net: "Net propriétaires",
      netRestricted: "Votre net",
    },
    ofGross: "des revenus",
    collectedByYou: "encaissé par vous",
    collectedByManager: "encaissé par votre gestionnaire",
    commissionLine: "{commission} + TVA {vat}",
    otaLine: "{commission} + TVA {vat}",
    otaTitle: "Commission des OTA {commission} + TVA {vat}",
    commissionTitle: "Commission {commission} + TVA {vat}",
    toTransfer: "À verser aux propriétaires",
    toCollect: "À facturer aux propriétaires",
    toTransferRestricted: "Votre gestionnaire vous verse",
    toCollectRestricted: "À payer à votre gestionnaire",
    chartTitle: "Répartition des encaissements",
    chartA11y: "Graphique de la répartition des revenus des réservations gérées",
    legend: {
      net: "Net propriétaires",
      netRestricted: "Votre net",
      commissions: "Vos commissions",
      commissionsRestricted: "Commission du gestionnaire",
      ota: "Commissions OTA",
      cleaning: "Ménage",
      other: "Taxes, cautions, TVA et frais",
    },
    grossFooter: "Revenus : {amount}",
    tableTitle: "Relevé par propriétaire",
    tableTitleRestricted: "Détail de votre relevé",
    downloadAll: "Tout télécharger (PDF)",
    download: "Télécharger (PDF)",
    downloading: "Téléchargement…",
    pdf: "PDF",
    excel: "Excel",
    exportError: "Impossible de télécharger le relevé.",
    cols: {
      owner: "Propriétaire",
      reservations: "Réservations",
      gross: "Revenus",
      ota: "OTA",
      cleaning: "Ménage",
      commission: "Commission + TVA",
      charged: "Frais",
      net: "Net",
      balance: "Solde",
      actions: "Téléchargements",
    },
    noOwner: "Sans propriétaire attribué",
    transfer: "À verser {amount}",
    collect: "À facturer {amount}",
    receive: "À recevoir {amount}",
    pay: "À payer {amount}",
    collectionManager: "Encaissé par le gestionnaire",
    collectionOwner: "Encaissé par le propriétaire",
    total: "Total",
    expand: "Afficher le détail de {name}",
    collapse: "Masquer le détail de {name}",
    iban: "IBAN {iban}",
    showReservations: "Voir les réservations ({count})",
    hideReservations: "Masquer les réservations",
    noData: "Aucune réservation gérée sur cette période.",
    reservations: {
      checkIn: "Arrivée",
      checkOut: "Départ",
      guest: "Voyageur",
      listing: "Hébergement",
      channel: "Canal",
      gross: "Revenus",
      ota: "OTA",
      cleaning: "Ménage",
      commission: "Commission",
      vat: "TVA",
      net: "Net",
      direct: "Directe",
      estimated: "est.",
      estimatedHelp: "Estimée au pourcentage : le canal n'a pas transmis la commission réelle.",
      noBreakdown: "sans détail",
      noBreakdownHelp: "La réservation n'a pas de détail : tout son montant a été compté comme hébergement.",
      complete: "Complete",
      completed: "Completed",
      completeHelp: "Fill in cleaning, the real OTA commission or the cleaning for this booking",
      manual: "manual",
      manualHelp: "OTA commission entered by hand for this booking.",
      loading: "Chargement des réservations…",
      loadError: "Impossible de charger les réservations.",
      empty: "Aucune réservation sur cette période.",
    },
    charged: {
      title: "Frais refacturés au propriétaire",
      date: "Date",
      concept: "Libellé",
      listing: "Hébergement",
      amount: "Montant",
      general: "Général",
    },
  },

  a11y: {
    views: "Sections de gestion",
  },
  // Liquidación por propietario: la cuenta y las columnas del PDF.
  liq: {
    precio: "Prix",
    comision: "Commission OTA",
    tasas: "Taxes",
    limpieza: "Ménage",
    honorarios: "Honoraires",
    honorariosIva: "Honoraires + TVA",
    neto: "Net propriétaire",
    transfieres: "Vous virez",
    tePaga: "Il vous paie",
    recibes: "Vous recevez",
    pagas: "Vous payez",
    netoPropietarios: "Net pour les propriétaires",
    formula: "Revenu = Prix − Commission · Total = Revenu − Taxes − Ménage · Net = Total − Honoraires − TVA. Comme dans le PDF et l'Excel.",
    cols: {
      origen: "Origine",
      nombre: "Nom",
      entrada: "Arrivée",
      salida: "Départ",
      precio: "Prix",
      noches: "Nuits",
      comision: "Commission",
      ingreso: "Revenu",
      tasas: "Taxes",
      limpieza: "Ménage",
      total: "Total",
      honorarios: "Honoraires",
      iva: "TVA",
      neto: "Net",
    },
  },
};
